import { pathOr, map, append, lensPath, set } from 'ramda';
import { compose } from 'recompose';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { authenticatedUser } from '../storage';

export const mkNewPushNotifications = (
  notificationProp: any,
  pushId: string[]
) => {
  return {
    account_id: authenticatedUser.accountId.get(),
    notifications_id: pushId,
    notification_type: pathOr('', ['notificationType'], notificationProp),
    data: {
      title: pathOr('', ['notificationTitle'], notificationProp),
      message: pathOr('', ['notificationMessage'], notificationProp),
      redirect_to: pathOr('', ['notificationRedirection'], notificationProp),
    },
    object_meta: {
      namespace: getNamespaceName()
    },
    created_at: 'now()',
    updated_at: 'now()',
    mark_as_read: [],
  };
};

export const mkUpdateNotificationAsSeen = (notifications: any) => {
  const statusUpdateFn = (notification: any) => {
    return compose(
      set(
        lensPath(['mark_as_read']),
        append(
          authenticatedUser.accountId.get(),
          pathOr([], ['mark_as_read'], notifications)
        )
      ),
      set(lensPath(['updated_at']), 'now()')
    )(notification);
  };
  return map(statusUpdateFn, notifications);
};
